module.exports = __webpack_public_path__ + "static/img/fosho_copilot2.505d9fb4.png";